module.exports = __webpack_public_path__ + "static/img/bg_font.4fa335d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/english-certificate/images/bg_font.jpg
// module id = ToU2
// module chunks = 7